import { get, patch } from "../../config/api";

export const Subscription = {
  getAll: () => get("subscriptions"),
  edit: ({ id, payload }: { id: string; payload: any }) =>
    patch(`subscriptions/${id}`, { json: { ...payload } }),
};
